import React from "react";
import pic2 from "../../../images/galleryimage/pic2.jpg";
import arch from "../../../images/galleryimage/arch.jpeg";
const GalllerySection3 = () => {
  return (
    <div className="mt-40 items-center justify-evenly lg:flex overflow-hidden">
      <div className="lg:w-[50%]">
        <img className="lg:w-full rounded-l-full" src={arch} alt="" />
      </div>
      <div className="bg-white pb-10 lg:w-[40%]">
        <div className="">
          <h1 className="mt-11 text-5xl font-bold mx-5">Arcade</h1>
          <h2 className="mt-4 text-2xl font-bold text-gray-700"></h2>
          <p className="mt-8 text-xl leading-8 mx-5">
            Organized sports participation may aid in the development of
            physical skills, such as hand-eye coordination; functional movement
            skills and strength; and academic, self-regulatory, and general life
            skills. It also may have positive social benefits, leading to both
            improved social identity and social adjustment.
          </p>
          <br />
          <br />
          <hr />
          <br />
          <p className="text-xl text-center">
            .. Interactivity (with Others) Focus. ... Critical Thinking. ...
            Production. ... Problem Solving. ... Reflection.
          </p>
          <div className="overflow-hidden  mx-3 ">
            <button className="mt-10 w-[100%]   cursor-pointer bg-black lg:px-8  py-5 text-xl lg:w-full font-semibold   text-white">
              ...........................::|||||||||||::............................
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalllerySection3;
